module.exports = __webpack_public_path__ + "images/72c1c0134b521a03b6b69b2666149272.jpg";


//////////////////
// WEBPACK FOOTER
// ../public/images/beer.jpg
// module id = 445
// module chunks = 0